/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha31 = props => (
  <svg viewBox="0 0 30 30" width="1em" height="1em" {...props}>
    <g id="Frame">
      <rect x="1.5" y="3.5" width="26.8" height="20.4" rx="6" ry="6"/>
    </g>
    <g id="Line">
      <rect strokeMiterlimit={10} strokeWidth={`.25px`} fill={`none`} className="stroke-svg-bg" x="3.88" y="6.06" width="21.8" height="15.4" rx="4" ry="4"/>
    </g>
    <g id="LED">
      <circle strokeMiterlimit={10} strokeWidth={`.25px`} className="fill-svg-secondary" cx="14.82" cy="19.29" r="1.24"/>
    </g>
  </svg>
);
export default extendIcon(Deha31);
